<div class="az-table-container">
  <table class="az-table">
    <thead class="az-table-header">
      <tr>
        @for (column of columns; track column.key) {
          <th
            class="az-table-th"
            [style.width]="getColumnWidth(column)"
            [style.min-width]="getColumnMinWidth(column)"
            [style.max-width]="getColumnMaxWidth(column)"
            [style.text-align]="getColumnAlign(column)"
          >
            {{ column.label }}
          </th>
        }
        @if (actions.length > 0) {
          <th class="az-table-th az-table-th--actions"></th>
        }
      </tr>
    </thead>
    <tbody class="az-table-body">
      @if (data.length === 0) {
        <tr>
          <td [attr.colspan]="columns.length + (actions.length > 0 ? 1 : 0)" class="az-table-empty">
            {{ emptyMessage }}
          </td>
        </tr>
      }
      @for (row of data; track $index) {
        <tr class="az-table-row" (click)="onRowClick(row)">
          @for (column of columns; track column.key) {
            <td class="az-table-td" [style.text-align]="getColumnAlign(column)">
              {{ getCellValue(row, column) }}
            </td>
          }
          @if (actions.length > 0) {
            <td class="az-table-td az-table-td--actions">
              <div class="az-table-actions">
                @for (action of actions; track action.label) {
                  <button
                    class="az-table-action-btn"
                    [attr.aria-label]="action.label"
                    [title]="action.label"
                    (click)="onActionClick(action, row, $event)"
                  >
                    <span class="material-symbols-outlined">{{ action.icon }}</span>
                  </button>
                }
              </div>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
